<template>
  <div>
    <v-autocomplete
      color="primary"
      hide-no-data
      v-model="supplierSelected"
      :clearable="!unclearable"
      :items="suppliersItems"
      :loading="suppliersLoading"
      :search-input.sync="suppliersSearch"
      item-text="Description"
      item-value="id"
      return-object
      :single-line="dense"
      :dense="dense"
      :hide-details="dense"
      :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
      @change="$emit('supplierSelected', supplierSelected)"
    ></v-autocomplete>

    <v-dialog v-model="bindMaterialDialog" max-width="900px">
      <v-card>
        <v-card-title class="ma-3">
          {{
            $t("PurchasesDetail.get_relation_ship.title", [
              supplierSelected ? supplierSelected.supplier_name : "",
              material.material_name,
            ])
          }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  bindMaterialDialog = false;
                  supplierSelected = null;
                "
              >
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <div class="ma-4">
          <ValidationObserver ref="observer">
            <v-data-table
              :headers="headers"
              :items="getRelationShip"
              :loading="loading"
              multi-sort
              class="elevation-0 px-6"
              v-resize="resizeHeader"
              :footer-props="footerProps"
            >
              <template v-slot:item.material_category.name="{ item }">
                <span v-if="supplierSelected && supplierSelected.type == 1">
                  {{ item.material_category.name }}
                </span>
                <span
                  v-else-if="supplierSelected && supplierSelected.type == 2"
                >
                  {{ item.category_name }}
                </span>
              </template>
              <!-- 供货编码 -->
              <template v-slot:item.supply_code="{ item }">
                <div>
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="item.supply_code"
                    :value="item.supply_code"
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </template>
              <template v-slot:item.supply_unit="{ item }">
                <v-select
                  v-model="item.supply_unit"
                  :items="item.standard.standard_details"
                  item-value="id"
                  item-text="unit"
                  return-object
                  single-line
                  dense
                  hide-details
                  style="max-width: 60px; margin-left: auto"
                ></v-select>
              </template>
              <template v-slot:item.price="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('PurchasesDetail.get_relation_ship.price')"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.price"
                    single-line
                    dense
                    type="number"
                    min="0"
                    :prefix="$t('Global.money')"
                    @blur="
                      item.price = $numberFormatter.formatWithDotNoMoreThan(
                        item.price,
                        2
                      )
                    "
                    style="max-width: 80px; margin-left: auto"
                    hide-details
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </template>
              <template v-slot:item.tax_flg="{ item }">
                <div class="d-flex mt-n2 mb-n3">
                  <v-checkbox
                    color="primary"
                    v-model="item.tax_flg"
                    :true-value="1"
                    :false-value="0"
                  >
                    <template v-slot:label>
                      <span class="caption ms-n2">
                        {{
                          $t(
                            item.tax_flg
                              ? "SupplierMaterials.Fields.tax_on"
                              : "SupplierMaterials.Fields.tax_off"
                          )
                        }}
                      </span>
                    </template>
                  </v-checkbox>
                </div>
              </template>
              <template v-slot:item.tax_rate="{ item }">
                <v-select
                  single-line
                  dense
                  hide-details
                  style="max-width: 60px; margin-left: auto"
                  :items="taxRateArr"
                  item-text="value"
                  item-value="key"
                  v-model="item.tax_rate"
                  suffix="%"
                />
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click="bindMaterial(item)"
                >
                  {{ $t("PurchasesDetail.actions.bind") }}
                </v-btn>
              </template>
            </v-data-table>
          </ValidationObserver>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            class="elevation-1"
            @click="
              bindMaterialDialog = false;
              supplierSelected = null;
            "
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SupplierMaterials from "@/api/supplier_materials";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "SearcherProductSupplier",
  props: {
    value: Object,
    supplierLists: Array,
    material: Object,
    stock: Object,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    headers() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.get_relation_ship.category"),
          align: "start",
          sortable: false,
          value: "material_category.name",
        },
        {
          text: i18n.t("PurchasesDetail.get_relation_ship.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("PurchasesDetail.get_relation_ship.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
      ];
      if (this.supplierSelected && this.supplierSelected.type == 2) {
        headers.push({
          text: i18n.t("PurchasesDetail.get_relation_ship.order_unit"),
          align: "center",
          sortable: false,
          value: "unit",
        });
      }
      headers.push(
        {
          text: i18n.t("PurchasesDetail.get_relation_ship.supply_code"),
          align: "end",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("PurchasesDetail.get_relation_ship.purchase_unit"),
          align: "center",
          sortable: false,
          value: "supply_unit",
        }
      );
      if (this.supplierSelected && this.supplierSelected.type == 1) {
        headers.push({
          text: i18n.t("PurchasesDetail.get_relation_ship.price"),
          align: "end",
          sortable: false,
          value: "price",
        });
      }
      if (this.settings && this.settings.use_tax == 1) {
        headers.push(
          {
            text: i18n.t("PurchasesDetail.get_relation_ship.tax_flg"),
            align: "center",
            sortable: false,
            value: "tax_flg",
          },
          {
            text: i18n.t("PurchasesDetail.get_relation_ship.tax_rate"),
            align: "center",
            sortable: false,
            value: "tax_rate",
          }
        );
      }
      return headers.concat([
        {
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]);
    },

    suppliersItems() {
      return this.suppliers.map((suppliers) => {
        suppliers.supplier_price_display =
          suppliers.material_negotiate_price_flg == 1
            ? this.$t("PurchasesDetail.purchaseFields.negotiatePrices")
            : suppliers.supplier_price_display;
        const Description =
          suppliers.supplier_name + " / " + suppliers.supplier_price_display;
        return Object.assign({}, suppliers, { Description });
      });
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    getRelationShip: [],
    suppliers: [],
    suppliersLoading: false,
    suppliersSearch: "",
    supplierSelected: null,
    bindMaterialDialog: false,
    itemsPerPageOptions: 10,
    taxRateArr: [],
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    getSuppliersFromAPI() {
      SupplierMaterials.fetchRelation({
        material_id: this.material.material_id,
        supplier_id: this.supplierSelected.id,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (
              response.data.suppliers.length &&
              response.data.suppliers[0].type == 2
            ) {
              this.getRelationShip =
                response.data.suppliers[0].supplier_materials;
            } else {
              this.getRelationShip = [response.data.material];
            }
          }
        }.bind(this)
      );
    },
    bindMaterial(materialDetail) {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (materialDetail.price) {
              var supplier_material_relation = {
                standard_detail_id: materialDetail.supply_unit.id,
                supply_price: materialDetail.price
                  ? materialDetail.price
                  : materialDetail.in_price,
                supply_code: materialDetail.supply_code
                  ? materialDetail.supply_code
                  : "",
                material_id: materialDetail.id,
                tax_flg: materialDetail.tax_flg ? materialDetail.tax_flg : 0,
                tax_rate: materialDetail.tax_rate,
              };

              SupplierMaterials.batchSave({
                supplier_id: this.supplierSelected.id,
                supplier_material_relations: [supplier_material_relation],
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.refreshSuppliers();
                  }
                }.bind(this)
              );
            }
          }
        }.bind(this)
      );
    },
    refreshSuppliers() {
      SupplierMaterials.fetchProduct({
        stock_id: this.stock.id,
        material_ids: [this.material.material_id],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.suppliers = response.data.materials[0].suppliers;
            this.$emit("refreshSuppliers", this.suppliers);
            this.$snackbar.success(
              i18n.t("PurchasesDetail.Messages.bindSupplierMaterialSuccess")
            );
            this.bindMaterialDialog = false;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.supplierSelected = this.value;
      },
    },
    supplierLists: {
      immediate: true,
      handler() {
        this.suppliers = this.supplierLists;
      },
    },
    settings: {
      immediate: true,
      handler() {
        var tax_setting = Object.values(this.settings.tax_setting);
        this.taxRateArr = tax_setting.map((tax) => {
          return { key: Number(tax), value: Number(tax) };
        });
      },
    },
    supplierSelected: {
      handler() {
        if (this.supplierSelected) {
          this.$emit("input", this.supplierSelected);
          if (
            !this.supplierSelected.supplier_price &&
            this.supplierSelected.supplier_price !== 0
          ) {
            this.getSuppliersFromAPI();
            this.bindMaterialDialog = true;
          }
        }
      },
    },
    bindMaterialDialog: {
      handler() {
        if (!this.bindMaterialDialog) {
          this.getRelationShip = [];
          this.supplierSelected = null;
        }
      },
    },
    getRelationShip: {
      handler() {
        if (this.getRelationShip.length) {
          this.getRelationShip.map((detail) => {
            detail.tax_rate = 0;
            if (!detail.supply_unit) {
              detail.supply_unit = detail.standard.default_standard_detail;
            }

            return detail;
          });
        }
      },
    },
  },
};
</script>
